import { htmlElem } from '../utils/globals';

const trigger = htmlElem.querySelector('.menu__toggle');
const header = htmlElem.querySelector('header');
const menuOpenClass = 'menu__open';
const navigationOpenClass = 'navigation__open';

const navigation = () => {
    trigger?.addEventListener('click', () => {
        if (header.classList.contains(menuOpenClass)) {
            resetNavigation();
        } else {
            header.classList.add(menuOpenClass);
            htmlElem.classList.add(navigationOpenClass);
            trigger.setAttribute('aria-label', 'Close navigation');
        }
    });
}

const resetNavigation = () => {
    header.classList.remove(menuOpenClass);
    htmlElem.classList.remove(navigationOpenClass);
    trigger.setAttribute('aria-label', 'Open navigation');
}

window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        resetNavigation();
    }
});

export {
    header,
    menuOpenClass,
    navigation,
    resetNavigation
}